import request from 'assets/js/http';

export function meetingDelete(id) {
  // 删除阶段
  return request({
    url: '/meeting/delete',
    method: 'post',
    data: { meetingId: id }
  });
}
export function queryFeishuDocInfo(url) {
  return request({
    url: '/feishu/doc/queryFeishuDocInfo',
    method: 'POST',
    data: {
      url: url
    }
  });
}

export function meetingAction(data) {
  // 新增-修改 阶段
  let url = '/meeting/add';
  if (data.id || data.id === 0) {
    url = '/meeting/edit';
  }
  data.companyIds = data.companyIds.join(',');
  return request({
    url: url,
    method: 'post',
    data
  });
}

export function companyList(data) {
  // 会议关联公司列表
  return request({
    url: '/company/listSimple',
    method: 'post',
    data
  });
}

//与会议相关的静态接口
export function meetingStaticInfo() {
  return request({
    url: '/common/getCommonList',
    method: 'post'
  });
}

//普通用户创建会议提交
export function askMeeting(data) {
  return request({
    url: '/meetingProject/add',
    method: 'post',
    data
  });
}

//普通用户编辑已提交会议，获取已创建会议信息
export function getEditMeetingInfo(data) {
  return request({
    url: '/meetingProject/detail',
    method: 'post',
    data
  });
}

//管理员用户创建会议提交
export function saveMeeting(data) {
  return request({
    url: '/meetingProject/manage',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

//管理员用户获取一个meeting信息
export function getMeetingInfo(data) {
  return request({
    url: '/meeting/detail',
    method: 'post',
    data
  });
}

// (旧-已弃用)会议管理页面普通用户获取会议列表
// export function meetingList(data) {
//   return request({
//     url: '/meeting/listPc',
//     method: 'post',
//     data
//   });
// }

//会议管理页面普通用户获取会议列表
export function meetingList(data) {
  return request({
    url: '/meeting/list',
    method: 'post',
    data
  });
}

//发送会议通知
export function meetingNotify(data) {
  return request({
    url: '/meeting/sendNotice',
    method: 'post',
    data
  });
}

//创建飞书群
export function createGroup(data) {
  return request({
    url: '/meetingProject/bindFeishuGroup',
    headers: {
      'content-type': 'application/json'
    },
    method: 'post',
    data
  });
}

// 查询项目会议关联群聊
export function getProjectGroup(data) {
  return request({
    url: '/meetingProject/group/query',
    method: 'post',
    data
  });
}

// 查询用户可见飞书群
export function getUserGroup(data) {
  return request({
    url: '/feishu/group/query',
    method: 'post',
    data
  });
}

// 获取群成员
export function obtainGroupUser(data) {
  return request({
    url: '/meetingProject/group/obtainUser',
    method: 'post',
    data
  });
}

// 获取会议数量
export function getMeetingProjectNum(data) {
  return request({
    url: '/meeting/getMeetingProjectNum',
    method: 'post',
    data
  });
}

// 查询会议dl
export function getDLList(data) {
  return request({
    url: '/meetingProject/dlList',
    method: 'post',
    data
  });
}

// 更新上会时间
export function updateTime(data) {
  return request({
    url: '/meetingProject/updateTime',
    method: 'post',
    data
  });
}

// 取消排会
export function meetingCancel(data) {
  return request({
    url: '/meetingProject/cancel',
    method: 'post',
    data
  });
}

export const meetProjectList = data => {
  return request({
    url: `/meetingProject/info`,
    method: 'POST',
    params: data
  });
};

// vote列表
export function getVoteList(data) {
  return request({
    url: '/projectVote/getVoteList',
    method: 'post',
    data
  });
}
// 关联飞书文件到天池会议
export const bingFeishuFile = data => {
  return request({
    url: '/meetingProject/bindFeishuFile',
    method: 'POST',
    params: data
  });
};
//关联飞书妙记到天池会议
export const bindFeishuAudio = data => {
  return request({
    url: '/meetingProject/bindFeishuAudio',
    method: 'POST',
    params: data
  });
};
// 录音上传
export const uploadMeetingProjectAudio = data => {
  return request({
    url: '/upload/uploadMeetingProjectAudio',
    method: 'POST',
    data: data,
    headers: {
      'content-type': 'multipart/form-data'
    }
  });
};
// 会议关联 飞书文件夹
export const queryFeishuFile = data => {
  return request({
    url: '/meetingProject/queryFeishuFile',
    method: 'POST',
    data: data
  });
};
export const bindFeishuFile = data => {
  return request({
    url: '/meetingProject/bindFeishuFile',
    method: 'POST',
    params: data
  });
};
export const feishuGroupMsgNotice = data => {
  return request({
    url: '/meetingProject/feishuGroupMsgNotice',
    method: 'POST',
    data: data
  });
};

// 查询项目当前会议状态
export function queryMeetingStatus(data) {
  return request({
    url: '/meetingProject/queryMeetingStatus',
    method: 'POST',
    data: data
  });
}

export function queryMeetingObtainUser(data) {
  console.log('data', data);
  return request({
    url: '/meetingProject/obtainUser',
    method: 'POST',
    data: data
  });
}

export function commitRealMeetingInfo(data) {
  return request({
    url: '/meetingProject/commitRealMeetingInfo',
    headers: {
      'content-type': 'application/json'
    },
    method: 'POST',
    data: data
  });
}